export default __webpack_public_path__ + "static/18-c156acd851d3e26c204686f77e28b006.webp";